import { motion } from "framer-motion";
import { SunIcon, MoonIcon } from "@heroicons/react/24/outline";
import { useDarkMode } from "../hooks/useDarkMode";
import { useSettings } from "../contexts/SettingsContext";

export default function SimpleHeader() {
  const { settings } = useSettings();
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <motion.header
      className="fixed left-0 right-0 top-0 z-50 bg-white/90 dark:bg-white/10 backdrop-blur-md border-b border-gray-200/50 dark:border-white/20"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <nav className="flex items-center justify-between px-4 sm:px-6 lg:px-8 py-4 max-w-7xl mx-auto">
        {/* Logo */}
        <motion.div
          className="flex lg:flex-1"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 400, damping: 17 }}
        >
          <a href="/" className="-m-1.5 p-1.5">
            <span className="sr-only">de5.ai</span>
            <h1
              className="text-2xl sm:text-3xl lg:text-4xl font-oxanium font-bold"
              style={{ color: settings.logoColor }}
            >
              de5.ai
            </h1>
          </a>
        </motion.div>

        {/* Right side - Dark mode toggle */}
        <div className="flex items-center gap-4">
          {/* Dark mode toggle */}
          <motion.button
            onClick={toggleDarkMode}
            className="p-2 rounded-lg bg-white/10 dark:bg-white/10 backdrop-blur-sm border border-gray-200/50 dark:border-white/20 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            aria-label="Toggle dark mode"
          >
            {isDarkMode ? (
              <SunIcon className="h-5 w-5" />
            ) : (
              <MoonIcon className="h-5 w-5" />
            )}
          </motion.button>
        </div>
      </nav>
    </motion.header>
  );
}
